module.exports = __webpack_public_path__ + "static/media/bridge.995e30e0.png";